"use client"

import Link from "next/link"

type NavItem = {
  href: string
  label: string
  external?: boolean
}

type MobileNavProps = {
  open: boolean
  items: readonly NavItem[]
  onClose: () => void
}

export function MobileNav({ open, items, onClose }: MobileNavProps) {
  if (!open) return null
  return (
    <div
      id="mobile-nav-panel"
      className="md:hidden absolute left-0 right-0 top-full z-40 border-b border-fg/10 bg-surface"
    >
      <ul className="flex flex-col py-2">
        {items.map((item) =>
          item.external ? (
            <li key={item.href}>
              <a
                href={item.href}
                target="_blank"
                rel="noreferrer noopener"
                onClick={onClose}
                className="block px-6 py-3 text-sm text-fg/80 hover:bg-fg/5"
              >
                {item.label}
              </a>
            </li>
          ) : (
            <li key={item.href}>
              <Link
                href={item.href}
                onClick={onClose}
                className="block px-6 py-3 text-sm text-fg/80 hover:bg-fg/5"
              >
                {item.label}
              </Link>
            </li>
          ),
        )}
      </ul>
    </div>
  )
}
